import React from 'react';

// Styles & Assets
import styles from './VIG.module.css';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import escalaVIG from '../../../assets/escala VIG.svg';

// Components
import Tooltip from '../../UI/Tooltip/Tooltip';

// interfaces
interface Props {
    value: number | null | undefined
}

// Constants
const WIDTH_IMAGE = 400;
const MARGIN_LEFT = 6;
const MARGIN_RIGHT = 5.5;
const customStyles: React.CSSProperties = {
    backgroundColor: '#fff',
    border: '2px solid var(--secondary-color)',
    borderRadius: '16px',
    padding: '20px',
    width: `${WIDTH_IMAGE}px`,
    boxSizing: 'content-box'
};


const VIG: React.FC<Props> = ({ value }) => {

    const leftPx = (x: number) => {
        return MARGIN_LEFT + (x * 1 / 0.7) * ((WIDTH_IMAGE - (MARGIN_LEFT + MARGIN_RIGHT)) / WIDTH_IMAGE) * WIDTH_IMAGE;
    };

    const getImageScale = (value: number) => (
        <div className={styles.container} style={{ width: '400px' }}>
            <img src={escalaVIG} className={styles.image} />
            <div className={styles.circle} style={{ left: leftPx(value) }}></div>
        </div>
    );

    return (
        <div className={styles.vigContainer}>
            <span>{value ?? '-'}</span>
            {typeof value === 'number' &&
                <Tooltip text={getImageScale(value)} customStyles={customStyles}>
                    <IoMdInformationCircleOutline className={styles.icon} />
                </Tooltip>
            }
        </div>
    );
};

export default VIG;